export const PRODUCT = 'PRODUCT';
export const FUNCTIONALITIES = 'FUNCTIONALITIES';
export const SECTORS = 'SECTORS';
export const TECHNOLOGY = 'TECHNOLOGY';
export const CONTACT_US = 'CONTACT_US';